import { Component, input } from '@angular/core';
import { CrntIcon } from '@essent/current-web-angular';
import { CoreJssProxyModule, TextField } from '@core/jss-proxy';
import type { IconIcon } from '@essent/current-web';

@Component({
  selector: 'wl-extended-usp',
  standalone: true,
  imports: [CoreJssProxyModule, CrntIcon],
  templateUrl: './extended-usp.component.html',
  styleUrls: [
    './extended-usp.component.ed.scss',
    './extended-usp.component.essent.scss',
  ],
})
export class ExtendedUspComponent {
  readonly uid = input.required<string>();
  readonly icon = input.required<IconIcon | undefined>();
  readonly title = input.required<TextField | undefined>();
  readonly description = input.required<TextField | undefined>();
}
